<template>
    <div class="airWaybillMainWrap">
        <div class="mainBill">
            <div class="title">
                <!-- 主单 -->
                <span class="text">{{$t('message.mainBill')}}</span>
                <!-- 联系货小二 -->
                <a v-if="customerService.qq !== '' && !overseasType"
                   class="contactXiaoEr"
                   target="_blank"
                   :href="$pcOrMobileQQ(customerService.qq)"
                   @click="$bigData('waiter','联系货小二','1')">{{$t('message.connectHXE')}}</a>
                <span v-if="customerService.email !== '' && overseasType"
                      class="contactXiaoEr"
                      @click="$emailContactUs({email: customerService.email}); $bigData('waiter','联系货小二','1');">{{$t('message.connectHXE')}}</span>
            </div>
            <!-- 主提单号 -->
            <div class="mainDoc">
                <!-- 主提单号 -->
                <div class="mainDocBox">
                    <div class="infoItem">{{$t('message.mainBillCode')}} {{mainBill.code}}</div>
                    <div v-if="billStatus.mainBill === '0'" 
                         class="modifyMianBtn"
                         @click="backToChangeMasterAirWayBill">
                        <img style="width: 18px; vertical-align: middle;" src="@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/dataToConfirm/makeBill/modify1.png"/>
                        主单制作
                    </div>
                    <div v-else class="oneRight">
                        <i v-if="mainBill.url !== ''" 
                           class="icon iconfont icon-renwuchaxun look"
                           @click="isShowCheckYLDialog = true;"></i>
                        <div  v-if="(billStatus.mainBill === '0' || (billStatus.mainBill === '1' && billStatus.mainBillConfirm === '0')) && billStatus.nameOfProductStatus !== '0'"
                              class="modify" 
                              @click="backToChangeMasterAirWayBill">
                            <img src="@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/dataToConfirm/makeBill/modify.png"/>
                        </div>
                    </div>
                </div>
                <!-- table表格 -->
                <div class="contentData">
                    <table>
                        <tr>
                            <td style="width: 64px;">件数</td>
                            <td style="width: 240px;">重量</td>
                            <td style="width: 64px;">计费重量</td>
                            <td style="width: 240px;">体积</td>
                        </tr>
                        <tr>
                            <td>{{mainBill.pieces ? mainBill.pieces : '--'}}</td>
                            <td>{{mainBill.weight ? mainBill.weight : '--'}}</td>
                            <td>{{mainBill.feeWeight ? mainBill.feeWeight : '--'}}</td>
                            <td>{{mainBill.volume ? mainBill.volume : '--'}}</td>
                        </tr>
                    </table>
                </div>
                <!-- 进仓编号 -->
                <div class="warehousing">
                    <p>进仓编号：{{mainBill.warehouseCode ? mainBill.warehouseCode : '--'}}</p>
                </div>
                <!-- 锂电池、非危鉴定、磁性鉴定 -->
                <div v-if="!isAllocationBoardOrder" class="battery">
                    <div style="cursor: pointer;" @click="battery">
                        <el-checkbox v-model="checked1"
                                     :disabled="billStatus.mainBillConfirm !== '0' || billStatus.nameOfProductStatus === '0'">锂电池</el-checkbox>
                    </div>
                    <span v-if="billStatus.mainBillConfirm !== '0' && checked1"
                          style=" margin-left: 5px; color: #009fe8; cursor: pointer;" 
                          @click="batteryLook = true">></span>
                    <div class="batteryBtn">
                        <el-checkbox v-model="checked2" 
                                     class="text" 
                                     :disabled="billStatus.mainBillConfirm !== '0' || billStatus.nameOfProductStatus === '0'"
                                     @change="postSelectAirWaybillServiceData('1')">非危鉴定</el-checkbox>
                    </div>
                    <div class="batteryBtn">
                        <el-checkbox v-model="checked3" 
                                     class="text"
                                     :disabled="billStatus.mainBillConfirm !== '0' || billStatus.nameOfProductStatus === '0'"
                                     @change="postSelectAirWaybillServiceData('2')">磁性鉴定</el-checkbox>
                    </div>
                </div>
                <div class="confirmBtn">
                    <el-button v-if="(billStatus.mainBill === '0' || billStatus.nameOfProductStatus === '2') && (billStatus.mainBillConfirm === '0' || !isAllocationBoardOrder)"
                               type="primary"
                               class="btnBox"
                               disabled>
                        主提单确认
                    </el-button>
                    <el-button v-if="billStatus.mainBill === '1' && billStatus.mainBillConfirm === '0' && billStatus.nameOfProductStatus === '0'"
                               type="primary"
                               class="btnBox"
                               disabled>
                        品名审核中
                    </el-button>
                    <el-button v-if=" billStatus.straight === '0' &&billStatus.mainBill === '1' && billStatus.mainBillConfirm === '0' && (billStatus.nameOfProductStatus === '' || billStatus.nameOfProductStatus === '1') && (billStatus.houseBillConfirm !== '0' || isAllocationBoardOrder) "
                               type="primary"
                               class="btnBox"
                               @click="isShowCheckMAWBDialog=true">
                        主提单确认
                    </el-button>
                    <el-button v-if=" billStatus.straight === '0' &&billStatus.mainBill === '1' && billStatus.mainBillConfirm === '0' && (billStatus.nameOfProductStatus === '' || billStatus.nameOfProductStatus === '1') && billStatus.houseBillConfirm === '0' && !isAllocationBoardOrder "
                               type="primary"
                               class="btnBox"
                               disabled>
                        主提单确认
                    </el-button>
                    <el-button v-if="billStatus.straight === '1' && billStatus.mainBill === '1' && billStatus.mainBillConfirm === '0' && (billStatus.nameOfProductStatus === '' || billStatus.nameOfProductStatus === '1')"
                               type="primary"
                               class="btnBox"
                               @click="isShowCheckMAWBDialog=true">
                        主提单确认
                    </el-button>
                    <el-button v-if="(billStatus.mainBill === '1' || isAllocationBoardOrder) && billStatus.mainBillConfirm === '1'"
                               type="primary"
                               class="btnBox"
                               disabled>
                        主提单已确认
                    </el-button>
                    <el-button v-if="(billStatus.mainBill === '1' || isAllocationBoardOrder) && billStatus.mainBillConfirm === '2'"
                               type="primary"
                               class="btnBox"
                               disabled>
                        主提单完成
                    </el-button>
                </div>
            </div>
            <!-- 锂电池弹框 -->
            <el-dialog title="锂电池"
                       :visible.sync="checkedBox"
                       custom-class="batteryLoading"
                       :close-on-click-modal="false"
                       :before-close="checkedClose"
                       width="32%"
                       top="15%">
                <div class="textarea">
                    <table class="lithiumBatteryTable" >
                        <tr>
                            <td>
                                <el-checkbox v-model="pi965checkbox"
                                             :disabled="mainBill.isEnablePI965 === '0'">PI965
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi965.count" class="numInput"></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI965手机号</span>
                                    <el-input v-model="mainBill.pi965.mobile" class="telInput"></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-checkbox v-model="pi967checkbox"
                                             :disabled="mainBill.isEnablePI967 === '0'">PI967
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi967.count" class="numInput"></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI967手机号</span>
                                    <el-input v-model="mainBill.pi967.mobile" class="telInput"></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-checkbox v-model="pi970checkbox"
                                             :disabled="mainBill.isEnablePI970 === '0'">PI970
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi970.count" class="numInput"></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI970手机号</span>
                                    <el-input v-model="mainBill.pi970.mobile" class="telInput"></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-checkbox v-model="pi966checkbox"
                                             :disabled="mainBill.isEnablePI966 === '0'">PI966
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi966.count" class="numInput"></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI966手机号</span>
                                    <el-input v-model="mainBill.pi966.mobile" class="telInput"></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-checkbox v-model="pi969checkbox"
                                             :disabled="mainBill.isEnablePI969 === '0'">PI969
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi969.count" class="numInput"></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI969手机号</span>
                                    <el-input v-model="mainBill.pi969.mobile" class="telInput"></el-input>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>


                <span slot="footer" class="dialog-footer">
                    <el-button type="primary"
                               class="preservation"
                               @click="postSelectAirWaybillServiceData('0')">保存</el-button>
                </span>
            </el-dialog>
            <el-dialog title="锂电池"
                       :visible.sync="batteryLook"
                       custom-class="batteryLoading"
                       :close-on-click-modal="false"
                       width="32%"
                       top="15%">
                <div class="textarea">
                    <table class="lithiumBatteryTable" >
                        <tr>
                            <td>
                                <el-checkbox v-model="pi965checkbox"
                                             disabled>PI965
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi965.count" 
                                              class="numInput"
                                              disabled></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI965手机号</span>
                                    <el-input v-model="mainBill.pi965.mobile" 
                                              class="telInput"
                                              disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-checkbox v-model="pi967checkbox"
                                             disabled>PI967
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi967.count" 
                                              class="numInput"
                                              disabled></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI967手机号</span>
                                    <el-input v-model="mainBill.pi967.mobile" 
                                              class="telInput"
                                              disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-checkbox v-model="pi970checkbox"
                                             disabled>PI970
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi970.count" 
                                              class="numInput"
                                              disabled></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI970手机号</span>
                                    <el-input v-model="mainBill.pi970.mobile" 
                                              class="telInput"
                                              disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-checkbox v-model="pi966checkbox"
                                             disabled>PI966
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi966.count"
                                              class="numInput"
                                              disabled></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI966手机号</span>
                                    <el-input v-model="mainBill.pi966.mobile" 
                                              class="telInput"
                                              disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-checkbox v-model="pi969checkbox"
                                             disabled>PI969
                                </el-checkbox>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">数量</span>
                                    <el-input v-model="mainBill.pi969.count"
                                              class="numInput"
                                              disabled></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="tdInnerBox">
                                    <span class="text">PI969手机号</span>
                                    <el-input v-model="mainBill.pi969.mobile" 
                                              class="telInput"
                                              disabled></el-input>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-dialog>
        </div>
        <div v-if="!isAllocationBoardOrder || billStatus.straight === '0'" 
             class="blank"
             :class="{active:billStatus.straight === '0' || (billStatus.straight === '1' && billStatus.mainBillConfirm === '0')}"></div>
        <div v-if="!isAllocationBoardOrder || billStatus.straight === '0'" class="splittingContent">
            <SJMLoading v-if="billListLoading"></SJMLoading>
            <div v-if="(billStatus.straight === '0' || (billStatus.straight === '1' && billStatus.mainBillConfirm === '0')) && billStatus.nameOfProductStatus !== '0'" class="title">{{$t('message.minorBill')}}<span v-if="makeHouseAirWaybillList.length > 0">{{makeHouseAirWaybillList.length}}份</span></div>
            <div class="container">
                <div v-if="billStatus.straight === '0'" class="billListContent">
                    <!-- 分单列表 -->
                    <div v-for="(item,index) in makeHouseAirWaybillList"
                         :key="item.index"
                         class="content">
                        <div class="ContentTitle">
                            <div class="contentText">
                                <span class="txt">分单{{index+1}}</span>
                                <span class="txt">{{item.houseBlCode}}</span>
                            </div>
                            <div class="titleBtn">
                                <i v-if="item.url" 
                                   class="icon iconfont icon-renwuchaxun look"
                                   @click="nowMinorBillIndex = index,isShowCheckHAWBDialog = true;"></i>
                                <img v-if="billStatus.houseBillConfirm === '0' || isAllocationBoardOrder && billStatus.mainBillConfirm === '0'"
                                     class="modify" 
                                     src="@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/dataToConfirm/makeBill/modify.png"
                                     @click="backToChangeHouseAirWayBill(index)">
                            </div>
                        </div>
                        <div class="contentTable">
                            <table>
                                <tr>
                                    <td style="width: 64px;">分单件数</td>
                                    <td style="width: 240px;">分单重量</td>
                                    <td style="width: 64px;">计费重量</td>
                                    <td style="width: 240px;">分单体积</td>
                                </tr>
                                <tr>
                                    <td>{{item.pieces ? item.pieces : '--'}}</td>
                                    <td>{{item.weight ? item.weight : '--'}}</td>
                                    <td>{{item.feeWeight ? item.feeWeight : '--'}}</td>
                                    <td>{{item.volume ? item.volume : '--'}}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-if="item.warehouseCodeList" class="contnetBottom">
                            <div class="warehouse">
                                <p>进仓编号：</p>
                                <p>{{item.warehouseCodeList[0]}}</p>
                                <el-tooltip placement="right">
                                    <img class="rightarrow" src="@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/dataToConfirm/makeBill/rightarrow.png"/>
                                    <div v-for="(data,val) in item.warehouseCodeList" 
                                         :key="val"
                                         slot="content">
                                        {{data}}
                                    </div>
                                </el-tooltip>
                                <p v-if="!isAllocationBoardOrder && billStatus.houseBillConfirm === '0'"
                                   class="modify"
                                   @click="getMakeHouseAirWaybillBindDetailData('1', item),modify = true,ind=index">修改分单数据</p>
                            </div>
                            <i v-if="!isAllocationBoardOrder && billStatus.houseBillConfirm === '0' && item.houseBillId" 
                               class="icon iconfont icon-shanchu1 delete"
                               @click="isDelete = true; deleteIndex = item.houseBillId"></i>
                        </div>
                    </div>
                </div>
                <div v-if="billStatus.houseBillConfirm === '0' && hideAdd === false && billStatus.mainBillConfirm === '0' && billStatus.nameOfProductStatus !== '0'" class="addSplitBox">
                    <div class="addSplit" @click="addSplit">
                        <span class="addition">+ </span>
                        <span class="text"> 添加分单</span>
                    </div>
                </div>
            </div>
            <div v-if="billStatus.straight === '0'"  class="contentBtn">
                <el-button v-if="mainBill.manifestUrl !== ''"
                           @click="isShowCheckCDXZDialog=true">
                    舱单下载
                </el-button>
                <el-button v-if="billStatus.houseBillConfirm === '0'" 
                           type="primary"
                           :disabled="isDisabled"
                           @click="reinsurance">分单确认</el-button>
                <el-button v-if="billStatus.houseBillConfirm === '1'"
                           disabled>分单已确认</el-button>
                <el-button v-if="billStatus.houseBillConfirm === '2'"
                           disabled>分单完成</el-button>
            </div>
        </div>

        
        <!-- 主单 查看/确认 Dialog -->
        <el-dialog title="主提单预览"
                   width="1000px"
                   top="5vh"
                   class="checkMAWBDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="isShowCheckMAWBDialog">
            <div class="checkDialogWrap">
                <p class="noSupportTip">{{$t('message.previewTip')}}</p>
                <iframe :class="{iframeHide: mainBillIframeHide}"
                        frameborder="0"
                        :src="urlType === '1' ? mainBill.url : mainBill.nobackgroundUrl"></iframe>
                <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end">
                    <el-switch v-model="urlType"
                               style="margin-right: 20px"
                               active-text="有背景"
                               active-value="1"
                               inactive-text="无背景"
                               inactive-value="0"></el-switch>
                    <div v-if="billStatus.mainBill === '1' && billStatus.mainBillConfirm === '0' && billStatus.nameOfProductStatus !== '0'" class="enlargeFt">
                        <el-button type="primary"
                                   size="medium"
                                   @click="confirmMainBill">
                            主提单确认
                        </el-button>
                    </div>
                </div>
            </div>
            <SJMLoading v-if="dialogLoading"></SJMLoading>
        </el-dialog>
        <!-- 主单 查看/确认 Dialog -->
        <el-dialog title="主提单预览"
                   width="1000px"
                   top="5vh"
                   class="checkMAWBDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="isShowCheckYLDialog">
            <div class="checkDialogWrap">
                <p class="noSupportTip">{{$t('message.previewTip')}}</p>
                <iframe :class="{iframeHide: mainBillIframeHide}"
                        frameborder="0"
                        :src="urlType === '1' ? mainBill.url : mainBill.nobackgroundUrl "></iframe>
                <div v-if="mainBill.urlDL" class="enlargeFt">
                    <el-switch v-model="urlType"
                               style="margin-right: 20px"
                               active-text="有背景"
                               active-value="1"
                               inactive-text="无背景"
                               inactive-value="0"></el-switch>
                    <a :href="urlType === '1' ? mainBill.urlDL : mainBill.nobackgroundUrlDL"
                       target="_blank"
                       download>
                        <el-button type="primary">
                            PDF下载
                        </el-button>
                    </a>
                </div>
            </div>
            <SJMLoading v-if="dialogLoading"></SJMLoading>
        </el-dialog>
        <!-- 分单 查看 Dialog -->
        <el-dialog v-if="makeHouseAirWaybillList.length !== 0"
                   width="1000px"
                   top="5vh"
                   class="checkMAWBDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="isShowCheckHAWBDialog">
            <div class="checkDialogWrap">
                <p class="noSupportTip">{{$t('message.previewTip')}}</p>
                <iframe frameborder="0"
                        :src="makeHouseAirWaybillList[nowMinorBillIndex].url"></iframe>
            </div>
        </el-dialog>
        
        <!--舱单下载 -->
        <el-dialog width="1000px"
                   top="5vh"
                   class="checkMAWBDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="isShowCheckCDXZDialog">
            <div class="checkDialogWrap">
                <p class="noSupportTip">{{$t('message.previewTip')}}</p>
                <iframe frameborder="0"
                        :src="mainBill.manifestUrl"></iframe>
                <div v-if="mainBill.manifestUrl" class="enlargeFt">
                    <a :href="mainBill.manifestUrl"
                       target="_blank"
                       download>
                        <el-button type="primary">
                            PDF下载
                        </el-button>
                    </a>
                </div>
            </div>
        </el-dialog>

        <!-- 添加分单确认弹框 -->
        <el-dialog :visible.sync="reconfirm"
                   :close-on-click-modal="false"
                   custom-class="frameBox"
                   width="20%"
                   top="20%">
            <span class="text">当前为直单，是否改为分单？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="reconfirm = false">取 消</el-button>
                <el-button type="primary" @click="getSelectAirWaybillTypeData">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 添加分单弹框 -->
        <el-dialog :visible.sync="numberCopies"
                   :close-on-click-modal="false"
                   custom-class="frameBox"
                   width="10%"
                   top="20%">
            <span class="text">分单</span>
            <el-input v-model.trim="score" 
                      placeholder="请填写分单份数"
                      class="policy"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="postSelectAirWaybillTypeData">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 判断当前所有分单是否都已制作完成弹框 -->
        <el-dialog :visible.sync="emptyPrompt"
                   :close-on-click-modal="false"
                   custom-class="frameBox"
                   width="20%"
                   top="20%">
            <span class="text">还有{{warehouseCodeNumber}}份分单未制作是否前去制作？</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="postHouseBillConfirmData">暂不制作</el-button>
                <el-button type="primary" @click="toChangeHouseAirWayBill">前往制作</el-button>
            </span>
        </el-dialog>

        <!-- 删除分单确定弹框 -->
        <el-dialog :visible.sync="isDelete"
                   :close-on-click-modal="false"
                   custom-class="frameBox"
                   width="20%"
                   top="20%">
            <span v-if="makeHouseAirWaybillList.length === 1" class="text">是否确认删除,当前制单状态将由分单变为直单？</span>
            <span v-else class="text">是否确认删除？</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="isDelete = false">取消</el-button>
                <el-button type="primary" @click="postDeleteHouseAirWaybillData">确认</el-button>
            </span>
        </el-dialog>

        <!-- 分单修改绑定进仓编号弹框 -->
        <el-dialog :visible.sync="modify"
                   custom-class="modifyBox"
                   :close-on-click-modal="false"
                   width="910px"
                   top="10%">
            <p class="text">绑定进仓编号</p>
            <div class="modifyContent">
                <span style=" font-size: 14px; color: #f0223b;">*</span>
                <span class="txt">分单{{ind+1}}</span>
                <el-input v-model="bindDetailInfo.houseBlCode"
                          placeholder="请输入分单号"
                          class="zxcInput"
                          maxlength="12"></el-input>
                <span class="txt1">分单件数</span>
                <el-input v-model="bindDetailInfo.pieces"
                          class="contentInput"></el-input>
                <span class="txt1">分单重量</span>
                <el-input v-model="bindDetailInfo.weight"
                          class="contentInput"></el-input>
                <span class="txt1">计费重量</span>
                <el-input v-model="bindDetailInfo.feeWeight"
                          class="contentInput"></el-input>
                <span class="txt1">分单体积</span>
                <el-input v-model="bindDetailInfo.volume"
                          class="contentInput"></el-input>
            </div>
            <div style="margin-top: 10px;">
                <div v-if="houseMustEoriCode === '1'"
                     class="textAreaBox"
                     style="align-items: flex-start">
                    <div class="title" style="flex-direction: column;margin-right: 10px;">
                        <div style="display: inline-block;font-size: 13px"><span class="star">*</span>EORI
                        </div>
                        <div style="display: inline-block;font-size: 12px;white-space: nowrap">(收货人税号)</div>
                    </div>
                    <input v-model.trim="houseEoriCode"
                           type="text"
                           style="box-sizing: border-box;width: 334px;resize: none;border: 1px solid #ccc;border-radius: 4px;padding: 10px;"
                           placeholder="请输入收货人纳税编号 例：TAX ID xx.xxx.xxxx"/>
                </div>
                <!--hscode-->
                <div v-if="houseMustHccCode === '1'"
                     class="textAreaBox"
                     style="border: 1px solid #DCDFE6;border-radius: 4px;background-color: #FFF;margin-top: 10px;flex-direction: column;width: 400px">
                    <div v-for="(item,index) in hccCodeList"
                         :key="index"
                         style="display: flex;margin-top: 8px;margin-left: 5px;margin-bottom: 5px;align-items: center;">
                        <div style="display: flex;flex-direction: row;align-items: center;margin-left: 20px;">
                            <div style="display: flex;justify-content: flex-end;flex-direction: column;margin-right: 10px;">
                                <div style="display: inline-block;font-size: 13px;white-space: nowrap;">
                                    <span class="star">*</span>HCC code
                                </div>
                                <div style="display: inline-block;font-size: 12px;white-space: nowrap">
                                    (统一商品编码)
                                </div>
                            </div>
                            <el-input v-model="item.hccCode"
                                      placeholder="HCC code"
                                      maxlength="6"
                                      style="width:200px;"
                                      resize="none"
                                      @input="changeHccCodeValue(item)"></el-input>
                        </div>
                        <div style="margin-left: 20px;">
                            <div v-if="index === hccCodeList.length - 1"
                                 class="iconOperating"
                                 @click="addHsCode">
                                <i class="icon">+</i>
                            </div>
                            <div v-else
                                 class="operating"
                                 @click="delHsCode(index)"
                            >{{ $t('message.delete') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-table :data="warehouseCodeList"
                      class="table"
                      :select-on-indeterminate="false">
                <el-table-column width="50px">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.isSelected"
                                     true-label="1"
                                     false-label="0"
                                     :disabled="scope.row.isHouseBlCode === true"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="code"
                                 label="进仓编号">
                </el-table-column>
                <el-table-column prop="houseBlCode"
                                 label="已绑分单号">
                </el-table-column>
                <el-table-column prop="pieces"
                                 label="件数">
                </el-table-column>
                <el-table-column prop="weight"
                                 label="重量">
                </el-table-column>
                <el-table-column prop="volume"
                                 label="体积">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary"
                           @click="postMakeHouseAirWaybillBindDetailDataCheck">提交</el-button>
            </span>
        </el-dialog>

        <!-- 分单添加绑定进仓编号弹框 -->
        <el-dialog :visible.sync="modifyAdd"
                   custom-class="modifyBox"
                   :close-on-click-modal="false"
                   width="910px"
                   top="10%">
            <p class="text">绑定进仓编号</p>
            <div class="modifyContent">
                <span style=" font-size: 14px; color: #f0223b;">*</span>
                <span class="txt">分单{{makeHouseAirWaybillList.length+1}}</span>
                <el-input v-model="bindDetailInfo.houseBlCode"
                          placeholder="请输入分单号"
                          class="zxcInput"
                          maxlength="12"></el-input>
                <span class="txt1">分单件数</span>
                <el-input v-model="bindDetailInfo.pieces"
                          class="contentInput"></el-input>
                <span class="txt1">分单重量</span>
                <el-input v-model="bindDetailInfo.weight"
                          class="contentInput"></el-input>
                <span class="txt1">计费重量</span>
                <el-input v-model="bindDetailInfo.feeWeight"
                          class="contentInput"></el-input>
                <span class="txt1">分单体积</span>
                <el-input v-model="bindDetailInfo.volume"
                          class="contentInput"></el-input>
            </div>
            <div style="margin-top: 10px;">
                <div v-if="houseMustEoriCode === '1'"
                     class="textAreaBox"
                     style="align-items: flex-start">
                    <div class="title" style="flex-direction: column;margin-right: 10px;">
                        <div style="display: inline-block;font-size: 13px"><span class="star">*</span>EORI
                        </div>
                        <div style="display: inline-block;font-size: 12px;white-space: nowrap">(收货人税号)</div>
                    </div>
                    <input v-model.trim="houseEoriCode"
                           type="text"
                           style="box-sizing: border-box;width: 334px;resize: none;border: 1px solid #ccc;border-radius: 4px;padding: 10px;"
                           placeholder="请输入收货人纳税编号 例：TAX ID xx.xxx.xxxx"/>
                </div>
                <!--hscode-->
                <div v-if="houseMustHccCode === '1'"
                     class="textAreaBox"
                     style="border: 1px solid #DCDFE6;border-radius: 4px;background-color: #FFF;margin-top: 10px;flex-direction: column;width:400px">
                    <div v-for="(item,index) in hccCodeList"
                         :key="index"
                         style="display: flex;margin-top: 8px;margin-left: 5px;margin-bottom: 5px;align-items: center;">
                        <div style="display: flex;flex-direction: row;align-items: center;margin-left: 20px;">
                            <div style="display: flex;justify-content: flex-end;flex-direction: column;margin-right: 10px;">
                                <div style="display: inline-block;font-size: 13px;white-space: nowrap;">
                                    <span class="star">*</span>HCC code
                                </div>
                                <div style="display: inline-block;font-size: 12px;white-space: nowrap">
                                    (统一商品编码)
                                </div>
                            </div>
                            <el-input v-model="item.hccCode"
                                      placeholder="HCC code"
                                      maxlength="6"
                                      style="width:200px;"
                                      resize="none"
                                      @input="changeHccCodeValue(item)"></el-input>
                        </div>
                        <div style="margin-left: 20px;">
                            <div v-if="index === hccCodeList.length - 1"
                                 class="iconOperating"
                                 @click="addHsCode">
                                <i class="icon">+</i>
                            </div>
                            <div v-else
                                 class="operating"
                                 @click="delHsCode(index)"
                            >{{ $t('message.delete') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-table :data="warehouseCodeList"
                      class="table"
                      :select-on-indeterminate="false">
                <el-table-column width="50px">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.isSelected"
                                     true-label="1"
                                     false-label="0"
                                     :disabled="scope.row.isHouseBlCode === true"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="code"
                                 label="进仓编号">
                </el-table-column>
                <el-table-column prop="houseBlCode"
                                 label="已绑分单号">
                </el-table-column>
                <el-table-column prop="pieces"
                                 label="件数">
                </el-table-column>
                <el-table-column prop="weight"
                                 label="重量">
                </el-table-column>
                <el-table-column prop="volume"
                                 label="体积">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary"
                           @click="postMakeHouseAirWaybillBindDetailDataCheck">提交</el-button>
            </span>
        </el-dialog>
        <SJMLoading v-if="pageLoading"></SJMLoading>
    </div>
</template>
<script>
    export default {
        name: 'AirWaybillMain',// 制单主页
        data() {
            return {
                orderBillCode: this.$route.query.orderBillCode,// 托单号
                pageLoading: false,// 页面 loading
                billListLoading: false,// 分单页面 loading
                ind: '',
                houseEoriCode: '',
                houseMustEoriCode: '0',// 分单是否必须收货人税号 0-N、1-Y
                houseMustHccCode: '0',// 分单是否必须HCC编码 0-N、1-Y
                hccCodeList: [],
                hsCodeList: [],
                postHccCodeList: [],
                // 主分单完成状态
                billStatus: {
                    straight: '',// 是否为直单 0-主分单出分单、1-直单/主分单不出分单
                    minorBillNumber: '',// 分单份数（主分单出分单才有）
                    mainBill: '',// 主单 0-未制作、1-已制作
                    mainBillModify: '',// 是否可以修改主分单 0-N、1-Y
                    mainBillConfirm: '',// 主提单确认标志 0-未确认、1-已确认
                    nameOfProductStatus: '',// 品名审核状态 空-无、0-品名审核中、1-品名审核通过、2-品名审核拒绝
                    houseBillConfirm: '',// 分单确认标志 0-未确认、1-已确认、2-已完成
                },
                // 主单
                mainBill: {
                    code: '',// 主单号
                    url: '',// 预览链接
                    urlDL: '',// 下载链接
                    nobackgroundUrl: '/xxx/xxx/xxx',// 无背景预览链接（无数据返回空字符串）（有运单号后有值）
                    nobackgroundUrlDL: '/xxx/xxx/xxx',// 无背景下载链接（无数据返回空字符串）（有运单号后有值）
                    pieces: '',// 件数（无数据返回空字符串）
                    weight: '',// 重量（无数据返回空字符串）
                    feeWeight: '',// 计费重量（无数据返回空字符串）
                    volume: '',// 体积（无数据返回空字符串）
                    warehouseCode: '',// 进仓编号
                    warehouseCodeList: [],// 进仓编号列表
                    isEnablePI965: '',// 是否启用PI965 0-N、1-Y
                    pi965: {
                        isSelected: '',// 是否选中 0-N、1-Y
                        count: '',// 数量
                        mobile: '',// 手机号
                    },
                    isEnablePI967: '',// 是否启用PI967 0-N、1-Y
                    pi967: {
                        isSelected: '',// 是否选中 0-N、1-Y
                        count: '',// 数量
                        mobile: '',// 手机号
                    },
                    isEnablePI970: '',// 是否启用PI970 0-N、1-Y
                    pi970: {
                        isSelected: '',// 是否选中 0-N、1-Y
                        count: '',// 数量
                        mobile: '',// 手机号
                    },
                    isEnablePI966: '',// 是否启用PI966 0-N、1-Y
                    pi966: {
                        isSelected: '',// 是否选中 0-N、1-Y
                        count: '',// 数量
                        mobile: '',// 手机号
                    },
                    isEnablePI969: '',// 是否启用PI969 0-N、1-Y
                    pi969: {
                        isSelected: '',// 是否选中 0-N、1-Y
                        count: '',// 数量
                        mobile: '',// 手机号
                    },
                    hasNonDangerousInspection: '',// 含有非危鉴定 0-N、1-Y
                    hasMagneticInspection: '',// 含有磁检鉴定 0-N、1-Y
                    nameOfProductMsg: '',// 不可接品名提示
                },
                // 货小二（每票货对应客服）
                customerService: {
                    qq: '',
                    email: '',
                    staffid: '',// 网易七鱼在线客服ID
                },
                // 锂电池绑定值
                pi965checkbox: '',
                pi967checkbox: '',
                pi970checkbox: '',
                pi966checkbox: '',
                pi969checkbox: '',
                isShowCheckMAWBDialog: false,// 是否显示主单查看
                isShowCheckYLDialog: false,// 是否显示主题单预览
                isShowCheckHAWBDialog: false,// 是否显示分单预览
                dialogLoading: false,// 弹窗loading
                isShowCheckCDXZDialog: false,// 舱单下载弹框
                mainBillIframeHide: false,// 主单iframe隐藏
                nowMinorBillIndex: 0,// 当前选中的分单下标
                reconfirm: false,// 直单转分单确认弹框
                emptyPrompt: false,// 判断分单是否都已制作loading
                
                checked1: false,// 锂电池是否选中
                checked2: false,// 非危鉴定是否选中
                checked3: false,// 磁性鉴定是否选中

                checkedBox: false,// 锂电池弹框
                numberCopies: false,// 添加分单弹框Loading
                score: '',// 添加分单弹框Loading绑定值
                modify: false,// 修改绑定进仓编号弹框
                modifyAdd: false,// 新增绑定进仓编号弹框

                // 绑定分单信息
                bindDetailInfo: {
                    type: '',// 当前绑定进仓编号类型 0-新增、1-修改
                    houseBillId: '',// 当前分单id
                    houseBlCode: '',// 当前分单号
                    pieces: '',// 件数
                    weight: '',// 重量
                    feeWeight: '',// 计费重量
                    volume: '',// 体积
                },
                
                selectAirWaybillType: '',// 是否选择制单类型 0-N、1-Y
                maxHouseBillNumber: '',// 最大分单数（无返回空字符串）
                // 分单列表
                makeHouseAirWaybillList: [],
                nameOfProductMsg: '',// 不可接品名提示
                // 分单
                minorBill: [
                    {
                        houseBillId: '',// 分单ID
                        houseBlCode: '',// 分单号
                        url: '',// 预览链接
                        urlDL: '',// 下载链接
                        warehouseCode: '',// 进仓编号
                        warehouseCodeList: [],// 进仓编号列表
                        pieces: '',// 件数
                        weight: '',// 重量  
                        feeWeight: '',// 计费重量
                        volume: '',// 体积
                        houseBillMake: '',// 分单制作 0-未制作、1-已制作
                    }
                ],
                warehouseCodeList: '',// 分单进仓编号列表
                hideAdd: true,// 添加分单显示与隐藏
                warehouseCodeNumber: 0,// 未制单份数
                isDisabled: false,// 分单确认是否置灰
                isDelete: false,// 删除确认弹框
                batteryLook: false,// 查看锂电池数据
                
                urlType: '1',
            };
        },
        computed: {
            // 海外用户标志
            overseasType() {
                return this.$store.state.Login.loginData.overseasType;
            },
            // 是否包板订单
            isAllocationBoardOrder() {
                return this.orderBillCode && this.orderBillCode.toUpperCase().startsWith('DSBO');
            }
        },
        async created() {
            // 获取 主分单制作主页数据
            await this.getMakeBillData();
            // 获取出口主分单制作单个分单绑定详情的数据
            this.getMakeHouseAirWaybillBindDetailData('0');
        },
        methods: {
            changeHccCodeValue(item) {
                this.$nextTick(() => {
                    item.hccCode = item.hccCode.replace(/[^\d]/g, '').trim();
                    if (item.hccCode.length > 6) {
                        item.hccCode = item.hccCode.substring(0, 6);
                    }
                });
            },
            addHsCode() {
                this.hccCodeList.push({hccCode: ''});
            },
            delHsCode(index) {
                this.hccCodeList.splice(index, 1);
            },
            // 分单确认
            reinsurance() {
                this.$bigData('confirmHouseBill','confirmHouseBill',this.orderBillCode);
                this.makeHouseAirWaybillList.forEach(i => {
                    // 判断所有分单是否都已制作
                    if (i.warehouseCode === '') {
                        this.warehouseCodeNumber++;
                        this.emptyPrompt = true;
                    }
                });
                if (this.warehouseCodeNumber === 0) {
                    this.$Confirm({
                        msg: '确定要分单确认吗？',
                        callback: () => {
                            this.postHouseBillConfirmData();
                        }
                    });
                    
                }
            },
            // 添加分单
            async addSplit() {
                // 是否为直单 是直单添加弹框确认
                if (this.billStatus.straight === '1') {
                    this.reconfirm = true;
                } else {
                    await this.getMakeBillData();
                    this.getMakeHouseAirWaybillListData();
                    this.getMakeHouseAirWaybillBindDetailData('0');
                    this.modifyAdd = true;
                }
            },
            // 选中锂电池弹框
            battery() {
                if (this.billStatus.mainBillConfirm === '0') {
                    this.checkedBox = true;
                    if (this.checked1 === false) {
                        setTimeout(() => {
                            this.checked1 = false;
                        }, 50);
                    } else {
                        setTimeout(() => {
                            this.checked1 = true;
                        }, 50);
                    }
                }
            }, 
            // 获取 主分单制作主页数据
            getMakeBillData() {
                return new Promise(resolve => {
                    this.checkedBox = false;
                    this.$ajax({
                        url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeBillHandler.ashx',
                        data: {
                            act: 'getMakeBillData',// 获取 主分单制作主页数据
                            orderBillCode: this.orderBillCode,// 托单号
                        },
                        beforeSend: () => {
                            this.pageLoading = true;
                        },
                        success: (res) => {
                            this.houseMustEoriCode = res.success.houseMustEoriCode;
                            this.houseMustHccCode = res.success.houseMustHccCode;
                            this.billStatus = res.success.billStatus;
                            this.mainBill = res.success.mainBill;
                            this.customerService = res.success.customerService;
                            if (this.mainBill.pi965.isSelected === '1' ||
                                this.mainBill.pi967.isSelected === '1' ||
                                this.mainBill.pi970.isSelected === '1' ||
                                this.mainBill.pi969.isSelected === '1' ||
                                this.mainBill.pi966.isSelected === '1') {
                                this.checked1 = true;
                            }
                            if (this.mainBill.pi965.isSelected === '0' &&
                                this.mainBill.pi967.isSelected === '0' &&
                                this.mainBill.pi970.isSelected === '0' &&
                                this.mainBill.pi969.isSelected === '0' &&
                                this.mainBill.pi966.isSelected === '0') {
                                this.checked1 = false;
                            }
                            if (this.mainBill.hasNonDangerousInspection === '1') {
                                this.checked2 = true;
                            }
                            if (this.mainBill.hasMagneticInspection === '1') {
                                this.checked3 = true;
                            }
                            // 锂电池弹框里的勾选
                            if (this.mainBill.pi965.isSelected === '1') {
                                this.pi965checkbox = true;
                            }
                            if (this.mainBill.pi967.isSelected === '1') {
                                this.pi967checkbox = true;
                            }
                            if (this.mainBill.pi970.isSelected === '1') {
                                this.pi970checkbox = true;
                            }
                            if (this.mainBill.pi966.isSelected === '1') {
                                this.pi966checkbox = true;
                            }
                            if (this.mainBill.pi969.isSelected === '1') {
                                this.pi969checkbox = true;
                            }

                            if (this.billStatus.straight === '1') {
                                this.hideAdd = false;
                            }
                            // 判断有没有分单
                            if (this.billStatus.straight === '0') {
                                // 获取 主分单制作分单列表的数据
                                this.getMakeHouseAirWaybillListData();
                            }

                            this.pageLoading = false;
                            resolve();
                        },
                        errCallback: () => {
                            this.pageLoading = false;
                            this.$router.push('/personalCenter/PersonalCenterMain');
                        }
                    });
                });
                
            },

            // 提交出口主分单制作分单确认的数据
            postHouseBillConfirmData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeBillHandler.ashx',
                    data: {
                        act: 'postHouseBillConfirmData',// 提交出口主分单制作分单确认的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    success: () => {
                        this.emptyPrompt = false,
                        this.$Alert({
                            type: 'success',
                            msg: '分单确认成功！',
                            callback: () => {
                                window.location.reload();
                            }
                        });
                    }
                });
            },
            
            // 关闭锂电池
            checkedClose() {
                this.getMakeBillData();
            },


            // 提交出口主分单制作选择服务的数据
            postSelectAirWaybillServiceData(type) {
                if (type === '0') {
                    if (this.pi965checkbox) {
                        if (this.mainBill.pi965.count === '' || this.mainBill.pi965.mobile === '' || this.mainBill.pi965.count === '0') {
                            this.$Message({
                                msg: '请将信息填写完整！'
                            });
                            return;
                        }
                    }
                    if (this.pi967checkbox) {
                        if (this.mainBill.pi967.count === '' || this.mainBill.pi967.mobile === '' || this.mainBill.pi967.count === '0') {
                            this.$Message({
                                msg: '请将信息填写完整！'
                            });
                            return;
                        }
                    }
                    if (this.pi970checkbox) {
                        if (this.mainBill.pi970.count === '' || this.mainBill.pi970.mobile === '' || this.mainBill.pi970.count === '0') {
                            this.$Message({
                                msg: '请将信息填写完整！'
                            });
                            return;
                        }
                    }
                    if (this.pi966checkbox) {
                        if (this.mainBill.pi966.count === '' || this.mainBill.pi966.mobile === '' || this.mainBill.pi966.count === '0') {
                            this.$Message({
                                msg: '请将信息填写完整！'
                            });
                            return;
                        }
                    }
                    if (this.pi969checkbox) {
                        if (this.mainBill.pi969.count === '' || this.mainBill.pi969.mobile === '' || this.mainBill.pi969.count === '0') {
                            this.$Message({
                                msg: '请将信息填写完整！'
                            });
                            return;
                        }
                    }

                }

                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeBillHandler.ashx',
                    data: {
                        act: 'postSelectAirWaybillServiceData',// 提交出口主分单制作选择服务的数据
                        orderBillCode: this.orderBillCode,// 托单号
                        type: type,// 0-锂电池、1-非危鉴定、2-磁检鉴定（根据type，对应字段需有值）
                        pi965: JSON.stringify({
                            isSelected: this.pi965checkbox === true ? '1' : '0',// 是否选中 0-N、1-Y
                            count: this.mainBill.pi965.count,// 数量
                            mobile: this.mainBill.pi965.mobile,// 手机号
                        }),
                        pi967: JSON.stringify({
                            isSelected: this.pi967checkbox === true ? '1' : '0',// 是否选中 0-N、1-Y
                            count: this.mainBill.pi967.count,// 数量
                            mobile: this.mainBill.pi967.mobile,// 手机号
                        }),
                        pi970: JSON.stringify({
                            isSelected: this.pi970checkbox === true ? '1' : '0',// 是否选中 0-N、1-Y
                            count: this.mainBill.pi970.count,// 数量
                            mobile: this.mainBill.pi970.mobile,// 手机号
                        }),
                        pi966: JSON.stringify({
                            isSelected: this.pi966checkbox === true ? '1' : '0',// 是否选中 0-N、1-Y
                            count: this.mainBill.pi966.count,// 数量
                            mobile: this.mainBill.pi966.mobile,// 手机号
                        }),
                        pi969: JSON.stringify({
                            isSelected: this.pi969checkbox === true ? '1' : '0',// 是否选中 0-N、1-Y
                            count: this.mainBill.pi969.count,// 数量
                            mobile: this.mainBill.pi969.mobile,// 手机号
                        }),
                        hasNonDangerousInspection: this.checked2 === true ? '1' : '0',// 含有非危鉴定 0-N、1-Y
                        hasMagneticInspection: this.checked3 === true ? '1' : '0',// 含有磁检鉴定 0-N、1-Y
                    },
                    success: () => {
                        this.$Message({
                            type: 'success',
                            msg: '保存成功！'
                        });
                        this.getMakeBillData();
                    }
                });
            },

            // 获取出口主分单制作选择制单类型的数据
            getSelectAirWaybillTypeData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeBillHandler.ashx',
                    data: {
                        act: 'getSelectAirWaybillTypeData',// 获取出口主分单制作选择制单类型的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    success: async (res) => {
                        this.reconfirm = false;
                        this.numberCopies = true;
                        this.selectAirWaybillType = res.success.selectAirWaybillType;
                        this.maxHouseBillNumber = res.success.maxHouseBillNumber;
                        if (this.maxHouseBillNumber !== '') {
                            this.score = this.maxHouseBillNumber;
                        }
                        await this.getMakeBillData();
                        this.getMakeHouseAirWaybillBindDetailData('0');
                    }
                });
            },
            // 提交出口主分单制作选择制单类型的数据
            postSelectAirWaybillTypeData() {
                if (Number(this.score) <= 0 || !this.score) {
                    this.$Message({
                        msg: '请输入分单份数！'
                    });
                    return;
                }
                if (this.maxHouseBillNumber !== '') {
                    if (Number(this.score) > Number(this.maxHouseBillNumber)) {
                        this.$Message({
                            msg: '您输入的分单份数已超最大分单数' + this.maxHouseBillNumber + '份！'
                        });
                        return;
                    }
                }
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeBillHandler.ashx',
                    data: {
                        act: 'postSelectAirWaybillTypeData',// 提交出口主分单制作选择制单类型的数据
                        orderBillCode: this.orderBillCode,// 托单号
                        straight: '0',// 是否为直单 0-主分单出分单、1-直单/主分单不出分单
                        houseBillNumber: this.score,// 分单份数（主分单出分单才有）
                    },
                    success: () => {

                        // 如果分单数据为空，添加分单隐藏
                        if (JSON.stringify(this.warehouseCodeList) === '[]') {
                            this.hideAdd = true;
                        }

                        this.numberCopies = false; 
                        
                        window.location.reload();
                        // this.getMakeBillData();
                        // this.getMakeHouseAirWaybillListData();
                        // this.getMakeHouseAirWaybillBindDetailData('0');
                    }
                });
            },
            // 获取出口主分单制作分单列表的数据
            getMakeHouseAirWaybillListData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeHouseBillHandler.ashx',
                    data: {
                        act: 'getMakeHouseAirWaybillListData',// 获取出口主分单制作分单列表的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.billListLoading = true;
                    },
                    success: (res) => {
                        this.makeHouseAirWaybillList = res.success.makeHouseAirWaybillList;
                        this.makeHouseAirWaybillList.forEach(i => {
                            if (i.houseBlCode === '') {
                                this.isDisabled = true;
                            }
                        });
                        this.billListLoading = false;
                    }
                });
            },
            // 获取出口主分单制作分单列表的数据
            getMakeHouseAirWaybillBindDetailData(type,row) {
                if (type === '0') {
                    this.bindDetailInfo = {
                        type: type,// 当前绑定进仓编号类型 0-新增、1-修改
                        houseBillId: '',// 当前分单id
                        houseBlCode: '',// 当前分单号
                        pieces: '0',// 件数
                        weight: '0',// 重量
                        feeWeight: '0',// 计费重量
                        volume: '0',// 体积
                    };
                } else {
                    this.bindDetailInfo = {
                        type: type,// 当前绑定进仓编号类型 0-新增、1-修改
                        houseBillId: row.houseBillId,// 当前分单id
                        houseBlCode: row.houseBlCode,// 当前分单号
                        pieces: row.pieces,// 件数
                        weight: row.weight,// 重量
                        feeWeight: row.feeWeight,// 计费重量
                        volume: row.volume,// 体积
                    };
                }
                // type为0时houseBillId传空
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeHouseBillHandler.ashx',
                    data: {
                        act: 'getMakeHouseAirWaybillBindDetailData',// 获取出口主分单制作单个分单绑定详情的数据
                        type: type,// 类型 0-新增、1-修改
                        orderBillCode: this.orderBillCode,// 托单号
                        houseBillId: this.bindDetailInfo.houseBillId,// 分单ID
                    },
                    beforeSend: () => {
                        this.hsCodeList = [];
                        this.houseEoriCode = '';
                        this.hccCodeList = [];
                    },
                    success: (res) => {
                        if (this.houseMustEoriCode === '1') {
                            this.houseEoriCode = res.success.eoriCode;
                        }
                        this.hsCodeList = res.success.hsCodeList;
                        if (this.houseMustHccCode === '1') {
                            this.hccCodeList = res.success.hccCodeList.map(temp => {
                                return {
                                    hccCode: temp
                                };
                            });
                            if (this.hccCodeList.length === 0) {
                                this.hccCodeList.push({hccCode: ''});
                            }
                        }
                        
                        
                        
                        this.warehouseCodeList = res.success.warehouseCodeList.map(data => {
                            return {
                                ...data,
                                isHouseBlCode: false,
                            };
                        });
                        if (this.billStatus.straight === '0') {
                            this.warehouseCodeList.forEach(item => {
                                if (item.houseBlCode === '') {
                                    this.isDisabled = true;
                                }
                                if (item.isSelected === '0' && item.houseBlCode !== '') {
                                    item.isHouseBlCode = true;
                                }
                            });
                            for (let i = 0; i < this.warehouseCodeList.length; i++) {
                                if (this.warehouseCodeList[i].houseBlCode === '') {
                                    this.hideAdd = false;
                                }
                            }
                        }
                    }
                });
            },
            postMakeHouseAirWaybillBindDetailDataCheck() {
                // 取出 勾选的进仓主键列表
                const inMainIdList = this.warehouseCodeList.filter(i => i.isSelected === '1').map(i => i.inMainId);

                let msg = '';
                if (this.bindDetailInfo.houseBlCode.length > 0 && !(/^[A-Za-z0-9]+$/).test(this.bindDetailInfo.houseBlCode)) {
                    msg = '分单号必须为字母或数字！';
                } else if (Number(this.bindDetailInfo.pieces) <= 0) {
                    msg = '分单件数必须为正数！';
                } else if (Number(this.bindDetailInfo.weight) <= 0) {
                    msg = '分单重量必须为正数！';
                } else if (Number(this.bindDetailInfo.feeWeight) <= 0) {
                    msg = '计费重量必须为正数！';
                } else if (Number(this.bindDetailInfo.volume) <= 0) {
                    msg = '分单体积必须为正数！';
                } else if (inMainIdList.length === 0) {
                    msg = '请选择一个进仓编号进行绑定！';
                }

                if (msg) {
                    this.$Message({
                        msg: msg
                    });
                    return;
                }

                if (this.houseMustEoriCode === '1' && this.houseEoriCode.trim() === '') {
                    this.$Message({
                        msg: '请填写收货人税号'
                    });
                    return;
                }


                let findInd = this.hccCodeList.findIndex(temp => temp.hccCode.trim() !== '');
                let notFindInd = this.hccCodeList.findIndex(temp => temp.hccCode.trim() === '');

                if (this.houseMustHccCode === '1' && findInd < 0) {
                    this.$Message({
                        msg: '请填写HCC Code'
                    });
                    return;
                }


                // 填过
                if (findInd >= 0 && notFindInd >= 0) {
                    this.$Message({
                        msg: '不要填写空的HCC Code'
                    });
                    return;
                }
                let hccCodes = this.hccCodeList.map(temp => {
                    return temp.hccCode;
                });
                // 完整填过hsCode
                if (findInd >= 0 && notFindInd < 0) {

                    if (hccCodes.length !== this.$distinct(hccCodes).length) {
                        this.$Message({
                            msg: 'HCC Code不能重复'
                        });
                        return;
                    }

                    for (let hccCode of hccCodes) {
                        if (hccCode.length !== 6) {
                            this.$Message({
                                msg: 'HCC Code需满足6位'
                            });
                            return;
                        }
                    }
                    for (let hccCode of hccCodes) {
                        if (hccCode.indexOf('.') >= 0) {
                            this.$Message({
                                msg: 'HCC Code必须为数字'
                            });
                            return;
                        }
                    }
                }

                let showConfirm = false;
                if (this.hsCodeList.length > 0) {
                    for (let hccCode of hccCodes) {
                        let fidIdx = this.hsCodeList.findIndex(temp => {
                            return temp.startsWith(hccCode);
                        });
                        if (fidIdx < 0) {
                            showConfirm = true;
                        }
                    }
                }
                this.postHccCodeList = hccCodes;
                if (showConfirm) {
                    this.$Confirm({
                        msg: '输入的HCC编码不在主单HS编码前6位中，是否继续？',
                        showCancelButton: true,
                        callback: () => {
                            this.postMakeHouseAirWaybillBindDetailData();
                        }
                    });
                } else {
                    this.postMakeHouseAirWaybillBindDetailData();
                }


            },
            // 提交出口主分单制作单个分单绑定详情的数据
            postMakeHouseAirWaybillBindDetailData() {
                // 取出 勾选的进仓主键列表
                const inMainIdList = this.warehouseCodeList.filter(i => i.isSelected === '1').map(i => i.inMainId);
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeHouseBillHandler.ashx',
                    data: {
                        act: 'postMakeHouseAirWaybillBindDetailData',// 提交出口主分单制作单个分单绑定详情的数据
                        orderBillCode: this.orderBillCode,// 托单号
                        type: this.bindDetailInfo.type,// 类型 0-新增、1-修改
                        houseBillId: this.bindDetailInfo.houseBillId,// 分单ID
                        houseBlCode: this.bindDetailInfo.houseBlCode,// 分单号
                        pieces: this.bindDetailInfo.pieces,// 件数
                        weight: this.bindDetailInfo.weight,// 重量
                        feeWeight: this.bindDetailInfo.feeWeight,// 计费重量
                        volume: this.bindDetailInfo.volume,// 体积
                        inMainIdList: JSON.stringify(inMainIdList),// 勾选的进仓主键列表
                        eoriCode: this.houseMustEoriCode === '1' ? this.houseEoriCode : '',// 收货人税号
                        hccCodeList: this.houseMustHccCode === '1' ? JSON.stringify(this.postHccCodeList) : '[]', // HS编码列表（不能重复）
                    },
                    success: () => {
                        this.modifyAdd = false;
                        this.modify = false;
                        this.$Alert({
                            type: 'success',
                            msg: '提交成功！',
                            callback: () => {
                                window.location.reload();
                            }
                        });
                        this.bindDetailInfo = {
                            type: '',// 当前绑定进仓编号类型 0-新增、1-修改
                            houseBillId: '',// 当前分单id
                            houseBlCode: '',// 当前分单号
                            pieces: '',// 件数
                            weight: '',// 重量
                            feeWeight: '',// 计费重量
                            volume: '',// 体积
                        };
                        // this.getMakeHouseAirWaybillListData();
                        // this.getMakeBillData();
                        // this.getMakeHouseAirWaybillBindDetailData('0');

                    }
                });
            },
            // 提交出口主分单删除单个分单的数据
            postDeleteHouseAirWaybillData() {
                this.isDelete = false;
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeHouseBillHandler.ashx',
                    data: {
                        act: 'postDeleteHouseAirWaybillData',// 提交出口主分单删除单个分单的数据
                        houseBillId: this.deleteIndex,// 分单ID
                    },
                    success: () => {
                        this.$Alert({
                            type: 'success',
                            msg: '删除成功！',
                            callback: () => {
                                window.location.reload();
                            }
                        });
                    }
                });
            },
            // 跳转 主单制作
            jumpToMakeMainBill() {
                this.$router.push({
                    path: '/personalCenter/PersonalCenterMain/operationCenter/cargoQuery/exportBusiness/makeBill/MakeMasterAirWaybill',
                    query: {
                        orderBillCode: this.orderBillCode,
                        straight: this.billStatus.straight
                    }
                });
                this.$bigData('addMajorBill', '添加主单', this.orderBillCode);
            },
            // 返回修改主单信息
            backToChangeMasterAirWayBill() {
                if (this.billStatus.mainBillConfirm !== '0') {
                    this.$Alert({
                        msg: this.$t('message.mainBillUpdateTip')
                    });
                } else {
                    this.jumpToMakeMainBill();
                }
                this.$bigData('updateMainBill', '返回修改', this.orderBillCode);
            },
            // 有分单没制作前往
            toChangeHouseAirWayBill() {
                for (let key in this.makeHouseAirWaybillList) {
                    if (this.makeHouseAirWaybillList[key].warehouseCode === '') {
                        this.$router.push(`/personalCenter/PersonalCenterMain/operationCenter/cargoQuery/exportBusiness/makeBill/MakeHouseAirWaybill?drCode=${this.mainBill.code}&houseBillId=${this.makeHouseAirWaybillList[key].houseBillId}&houseBlCode=${this.makeHouseAirWaybillList[key].houseBlCode}&orderBillCode=${this.orderBillCode}`);
                        break;
                    }
                }
            },
            // 制作/修改 分单信息
            backToChangeHouseAirWayBill(index) {
                this.$router.push(`/personalCenter/PersonalCenterMain/operationCenter/cargoQuery/exportBusiness/makeBill/MakeHouseAirWaybill?drCode=${this.mainBill.code}&houseBillId=${this.makeHouseAirWaybillList[index].houseBillId}&houseBlCode=${this.makeHouseAirWaybillList[index].houseBlCode}&orderBillCode=${this.orderBillCode}`);
            },
            // 主提单确认
            confirmMainBill() {
                // 隐藏iframe
                this.mainBillIframeHide = true;
                this.$Confirm({
                    type: '',
                    msg: this.$t('message.mainBillConfirmTip'),
                    callback: () => {
                        this.$ajax({
                            url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeBillHandler.ashx',
                            data: {
                                act: 'postMakeMainBillConfirmData',// 提交 主分单制作主页 提交主提单确认
                                orderBillCode: this.orderBillCode,// 托单号
                            },
                            beforeSend: () => {
                                this.dialogLoading = true;
                            },
                            errCallback: () => {
                                this.dialogLoading = false;
                                // 显示iframe
                                this.mainBillIframeHide = false;
                            },
                            success: (res) => {
                                this.nameOfProductMsg = res.success.nameOfProductMsg;
                                this.dialogLoading = false;
                                if (this.nameOfProductMsg !== '') {
                                    this.$Alert({
                                        msg: '存在不可接品名，平台审核中，如有疑问请联系货小二！',
                                        callback: () => {
                                            window.location.reload();
                                        }
                                    });
                                } else {
                                    this.$Alert({
                                        type: 'success',
                                        msg: this.$t('message.mainBillConfirmSuccess'),
                                        callback: () => {
                                            window.location.reload();
                                        }
                                    });
                                }
                            }
                        });
                    },
                    cancel: () => {
                        // 显示iframe
                        this.mainBillIframeHide = false;
                    }
                });
                this.$bigData('confirmMainBill', '弹窗-主提单确认', this.orderBillCode);
            }
        }
    };
</script>
<style lang="scss" scoped>
    .airWaybillMainWrap {
        position: relative;
        box-sizing: border-box;
        width: 1070px;
        min-height: 783px;
        padding: 30px 30px 0;
        background: white;

        .mainBill {
            position: relative;
            box-sizing: border-box;
            padding-bottom: 10px;
            margin-bottom: 20px;

            .title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 12px;
                font-size: 16px;

                .text {
                    font-size: 20px;
                    font-weight: bold;
                    color: #3f3a3a;
                }

                .contactXiaoEr {
                    color: #0aa7ee;
                }
            }

            .mainDoc {
                box-sizing: border-box;
                height: 284px;
                padding: 20px 30px;
                font-size: 16px;
                border: 1px solid #cdcdcd;
                border-radius: 4px;

                .mainDocBox {
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 20px;
                    border-bottom: 1px dashed #979797;

                    .infoItem {
                        font-size: 16px;
                        font-weight: bold;
                        color: #181818;
                    }

                    .oneRight {
                        display: flex;

                        .look {
                            margin-right: 20px;
                            font-size: 24px;
                            color: #0aa7ee;
                            cursor: pointer;
                        }
                    }

                    .modify {
                        cursor: pointer;
                    }

                    .modifyMianBtn {
                        padding: 4px 10px;
                        font-size: 14px;
                        line-height: 22px;
                        color: #f2fbff;
                        text-align: center;
                        cursor: pointer;
                        background: #0aa7ee;
                        border-radius: 2px;
                    }
                }

                .contentData {
                    margin-top: 20px;

                    table {
                        td {
                            height: 30px;
                        }
                    }
                }

                .warehousing {
                    margin-top: 10px;
                }

                .battery {
                    display: flex;
                    margin-top: 20px;

                    .text {
                        margin-left: 8px;
                        font-size: 14px;
                    }

                    .batteryBtn {
                        margin-left: 50px;
                    }
                }

                .confirmBtn {
                    text-align: right;

                    .btnBox {
                        width: 100px;
                        height: 36px;
                    }
                }
            }

            .batteryLoading {
                .textarea {
                    box-sizing: border-box;
                    min-height: 89px;
                    padding: 10px;
                    resize: none;
                    border: 1px solid #ccc;

                    .lithiumBatteryTable {
                        width: 100%;
                        padding: 10px 0;

                        td {
                            height: 40px;

                            .tdInnerBox {
                                display: flex;
                                align-items: center;

                                .text {
                                    margin-right: 20px;
                                }

                                .numInput {
                                    width: 80px;
                                }

                                .telInput {
                                    width: 200px;
                                }
                            }
                        }
                    }
                }

                .preservation {
                    width: 132px;
                    height: 42px;
                    font-size: 18px;
                }
            }
        }

        .blank {
            position: absolute;
            left: 0;
            width: 100%;
            height: 12px;
            background-color: #fff;
        }

        .active {
            position: absolute;
            left: 0;
            width: 100%;
            height: 12px;
            background-color: #eeeeef;
        }

        .splittingContent {
            height: 500px;
            margin-top: 50px;

            .title {
                font-size: 20px;
                font-weight: bold;
                color: #3f3a3a;
            }

            .container {
                width: 100%;
                height: 365px;
                overflow-y: scroll;

                &::-webkit-scrollbar {
                    display: none;
                }

                .billListContent {
                    width: 100%;
                    padding-bottom: 20px;

                    .content {
                        box-sizing: border-box;
                        width: 1008px;
                        height: 186px;
                        padding: 20px 30px;
                        margin-top: 15px;
                        border: 1px solid #cdcdcd;
                        border-radius: 4px;

                        .ContentTitle {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding-bottom: 16px;
                            border-bottom: 1px dashed #979797;

                            .contentText {
                                font-size: 16px;
                                font-weight: bold;
                                color: #181818;

                                .txt:nth-child(2) {
                                    margin-left: 10px;
                                }
                            }

                            .titleBtn {
                                .look {
                                    margin-right: 20px;
                                    font-size: 24px;
                                    color: #0aa7ee;
                                    cursor: pointer;
                                }

                                .modify {
                                    cursor: pointer;
                                }
                            }
                        }

                        .contentTable {
                            padding-top: 18px;
                            padding-bottom: 12px;

                            tr > td {
                                font-size: 16px;
                            }
                        }

                        .contnetBottom {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .warehouse {
                                display: flex;
                                align-items: center;

                                .rightarrow {
                                    height: 12px;
                                    margin: 0 12px;
                                    cursor: pointer;
                                }

                                .modify {
                                    padding: 0 8px;
                                    font-size: 14px;
                                    line-height: 22px;
                                    color: #f2fbff;
                                    text-align: center;
                                    cursor: pointer;
                                    background: #0aa7ee;
                                    border-radius: 2px;
                                }
                            }

                            .delete {
                                font-size: 22px;
                                color: #cdcdcd;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .addSplitBox {
                    width: 1008px;
                    height: 165px;
                    margin-top: 15px;
                    border: 1px solid #cdcdcd;
                    border-radius: 4px;

                    .addSplit {
                        width: 742px;
                        height: 44px;
                        margin: 50px auto;
                        line-height: 44px;
                        text-align: center;
                        cursor: pointer;
                        border: 1px solid #0aa7ee;
                        border-radius: 4px;

                        .addition {
                            font-size: 20px;
                            font-weight: bold;
                            color: #0aa7ee;
                        }

                        .text {
                            font-size: 16px;
                            color: #0aa7ee;
                        }
                    }
                }
            }

            .contentBtn {
                padding-top: 20px;
                text-align: right;

                button {
                    width: 100px;
                    height: 36px;
                    font-size: 14px;
                }
            }
        }

        .frameBox {
            height: 200px;

            .text {
                font-size: 22px;
            }

            .policy {
                margin-top: 12px;
            }
        }

        .modifyBox {
            .text {
                font-size: 22px;
            }

            .modifyContent {
                margin-top: 20px;

                .txt {
                    font-size: 14px;
                }

                .zxcInput {
                    width: 145px;
                    margin-left: 25px;
                }

                .txt1 {
                    margin-left: 30px;
                }

                .contentInput {
                    width: 56px;
                    margin-left: 20px;
                }
            }

            .table {
                max-height: 500px;
                padding-left: 20px;
                margin-top: 20px;
            }

            .textAreaBox {
                display: flex;
                justify-content: flex-start;
                //margin-bottom: 35px;

                .title {
                    display: flex;
                    justify-content: flex-end;
                    width: 58px;
                }

                .star {
                    color: #e83828;
                }

                .textarea {
                    box-sizing: border-box;
                    width: 860px;
                    min-height: 89px;
                    padding: 10px;
                    resize: none;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                }

                .textareaMiNi {
                    box-sizing: border-box;
                    width: 860px;
                    min-height: 42px;
                    padding: 10px;
                    resize: none;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                }

                .nameOfProductBox {
                    width: 860px;

                    .unacceptableListTips {
                        padding: 10px;
                        background-color: #f7f7f7;

                        .text {
                            margin-bottom: 15px;
                        }

                        .unacceptableItem {
                            margin-right: 50px;
                            color: #e73928;
                        }
                    }

                    .unacceptableBtn {
                        margin-top: 10px;
                    }
                }

                .operating {
                    width: 30px;
                    color: #0aa7ee;
                    text-align: center;
                    cursor: pointer;
                }

                .iconOperating {
                    width: 30px;
                    color: #0aa7ee;
                    text-align: center;

                    .icon {
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        font-style: normal;
                        color: white;
                        cursor: pointer;
                        background-color: #0aa7ee;
                        border-radius: 50%;
                    }
                }
            }
        }

        .checkDialogWrap {
            position: relative;
            text-align: center;

            .noSupportTip {
                margin-bottom: 10px;
                font-size: 16px;
                font-weight: bold;
                color: red;
            }

            iframe {
                width: 90%;
                height: 600px;
                margin-bottom: 30px;
                background-color: #fff;

                &.iframeHide {
                    visibility: hidden;
                }
            }

            .enlargeFt {
                text-align: right;
            }
        }
    }
</style>